import { defineStore } from 'pinia'
import { usePagination, useRequest } from '@/composables/useRequest.js'
import { computed, ref } from 'vue'

export const useAnnouncementStore = defineStore('announcement', () => {
  const { data, loading: fetching, execute: fetch } = usePagination('announcements')
  const { data: detail, execute: show } = useRequest()
  const labels = computed(() => new Set(data.value?.map(item => item.label).filter(label => ![null, ''].includes(label))))
  const tab = ref('all')

  return {
    data,
    fetching,
    fetch: async function (params) {
      if (params === undefined) {
        params = { category: 'default' }
      }
      await fetch('announcements', { params })
    },
    show: async (id) => await show(`/announcements/${id}`),
    detail,
    labels,
    tab
  }
})
